import image1 from '@/assets/images/news/detail/20200820/1.jpeg';

export default {
  id: '20200820', //  模块 id
  title: '叮咚买菜在南京开店，进一步布局华东市场', // 标题
  origin: '2020-08-20 09:48 来源：界面新闻', // 新闻来源
  editor: '记者：林北辰', // 编辑者
  content: [
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text:
        '8月20日，据界面新闻记者了解，由上海起家的前置仓模式生鲜电商叮咚买菜正式宣布进军南京。为了符合南京特色，叮咚买菜在南京地推海报中的宣传语为“鲜活鲫鱼6.66元一条”。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '叮咚买菜副总裁兼江苏事业部负责人颜现富介绍，除了开新城一律会推出的108元的新人大礼包外，6.66元一条的鲜活鲫鱼29分钟送到家是叮咚在南京的卖点。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '此次进驻南京，叮咚买菜首批将开出5个前置仓，并预计于今年12月底前在南京玄武区、鼓楼区等区域开设40个前置仓。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '在商品运营上，叮咚买菜表示，将根据南京用户的消费习惯做出本地化的调整。例如，增加更多本地品牌的供应，包括乳品品牌“卫岗”、豆制品品牌“豆果果”等。同时，在南京区域的叮咚买菜APP上也将对一些水产虾类的品名进行调整，比如将基围虾（明虾）在南京的名称变更为沙虾、大头虾变更为罗氏沼虾等。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '据叮咚买菜提供的数据，截至目前，已在上海、杭州、苏州、无锡、嘉兴等城市实现了核心城区的基本覆盖。南京是叮咚买菜在全国范围内入驻的第十一个城市，此前其已于北京、上海、深圳等十个城市开设600余家前置仓，日订单量达60万单，服务用户数达2000万。      ',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '此外，从产品品类上来看，叮咚买菜目前销售的80%生鲜食材为产地直采，分别来自山东、云南、宁夏等全国各地的超过350个直供基地和500家直供供应商。',
      isIndent: false,
    },
  ],
};
